import { render, staticRenderFns } from "./SocialsModal.vue?vue&type=template&id=3ddf10b1&scoped=true&"
import script from "./SocialsModal.vue?vue&type=script&lang=js&"
export * from "./SocialsModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialsModal.vue?vue&type=style&index=0&id=3ddf10b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf10b1",
  null
  
)

export default component.exports